import { Placeholder, VisitorIdentification } from '@sitecore-jss/sitecore-jss-react';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import UserLocationRequester from './UserLocationRequester';
var Layout = function (_a) {
    var _b, _c;
    var route = _a.route, placeholderName = _a.placeholderName;
    return (React.createElement(React.Fragment, null,
        React.createElement(Helmet, null,
            React.createElement("title", null, (route.fields && route.fields.pageTitle && route.fields.pageTitle.value) || 'Page')),
        React.createElement("div", null,
            React.createElement(VisitorIdentification, null),
            React.createElement(Placeholder, { name: placeholderName, rendering: route }),
            React.createElement(UserLocationRequester, { shouldRequestLocationOnLoad: (_c = (_b = route.fields) === null || _b === void 0 ? void 0 : _b.requestLocation) === null || _c === void 0 ? void 0 : _c.value }))));
};
export default Layout;
